// function openLink(evt, animName) {
//   var i, x, tablinks;
//   x = document.getElementsByClassName("city");
//   for (i = 0; i < x.length; i++) {
//     x[i].style.display = "none";
//   }
//   tablinks = document.getElementsByClassName("tablink");
//   for (i = 0; i < x.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" w3-red", "");
//   }
//   document.getElementById(animName).style.display = "block";
//   evt.currentTarget.className += " w3-red";
// }

import $ from "jquery";

const IndustryTabToggler = () => {
  const init = () => {
    SwitchTab();
  };

  const SwitchTab = () => {
    const el = {
      tabButton: "button.tab-button",
      tabContent: "div.city",
      tabImage: "img.tab-image",
    };

    $(el.tabButton).on("click", (e) => {
      const parent = $(e.target.closest(".industryTab"));

      parent.find($(el.tabButton)).addClass("inactive");
      parent.find($(el.tabContent)).addClass("inactive");
      parent.find($(el.tabImage)).addClass("inactive");
      parent.find(`.${$(e.target).attr("data-target")}`).removeClass("inactive");
    });
  };

  init();
};

try {
  IndustryTabToggler();
} catch (error) {
  console.log(error);
}
